import lobbySdk from '@corefront/eva-fe-sdk';
import { CANCEL } from 'redux-saga';
import { EVA_API_SERVICE_NAME } from '../constants/api';

let api;

export function initAPI({ baseUrl }) {
  api = lobbySdk({
    productType: EVA_API_SERVICE_NAME,
    abortMethodName: CANCEL,
    baseUrl,
  });
}

export function getAPI() {
  return api;
}
